<div class="sidebar-wrapper">
    <div>
        <ul>
            <li routerLink="/home" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
                <svg class="icon">
                    <use xlink:href="./assets/symbol-defs.svg#icon-home"></use>
                </svg>
            </li>
            <li>
                <a href="#/home/help" target="_blank">
                    <svg class="icon">
                        <use xlink:href="./assets/symbol-defs.svg#icon-help-circle"></use>
                    </svg>
                </a>
            </li>

            <ng-container *ngIf="is_admin">
                <li routerLink="/user-management" [routerLinkActive]="['active']" >
                    <svg class="icon">
                        <use xlink:href="./assets/symbol-defs.svg#icon-users"></use>
                    </svg>
                </li>
                <li routerLink="/settings" [routerLinkActive]="['active']">
                    <svg class="icon">
                        <use xlink:href="./assets/symbol-defs.svg#icon-settings"></use>
                    </svg>
                </li>
            </ng-container>
            
            <!---
            <li>
                <svg class="icon">
                    <use xlink:href="./assets/symbol-defs.svg#icon-file-text"></use>
                </svg>
            </li>
           
            <li>
                <svg class="icon">
                    <use xlink:href="./assets/symbol-defs.svg#icon-clock"></use>
                </svg>
            </li>
            <li>
                <svg class="icon">
                    <use xlink:href="./assets/symbol-defs.svg#icon-alert-triangle"></use>
                </svg>
            </li>
            <li>
                <svg class="icon">
                    <use xlink:href="./assets/symbol-defs.svg#icon-map"></use>
                </svg>
            </li>
            <li>
                <svg class="icon">
                    <use xlink:href="./assets/symbol-defs.svg#icon-terminal"></use>
                </svg>
            </li>
            -->
        </ul>
    </div>
</div>
